import React, { useContext, useEffect, useState } from "react";
import OptionsBox from "@ui/options-box";
import PageActionContext from "@stores/page-action-context";

const FormLoanReview = ({ data }) => {
    const pageActionCxt = useContext(PageActionContext);
    const [option, setOption] = useState(null);

    useEffect(() => {
        pageActionCxt.reset();
    }, []);

    const handleOptionSelected = (value) => {
        setOption(value);
        pageActionCxt.setNextClicked(false);
        pageActionCxt.setNextDisabled(!value);
    };

    useEffect(() => {
        pageActionCxt.setNextDisabled(true);
    }, []);

    useEffect(() => {
        if (pageActionCxt.isNextClicked) {
            handleNextClicked();
        }
    }, [pageActionCxt.isNextClicked]);

    const handleNextClicked = () => {
        const data = option && option.data;

        if (!data) return;

        const nextUrl = data.nextUrl;
        if (nextUrl) {
            pageActionCxt.setNextDisabled(false);
            pageActionCxt.navigate(nextUrl.url, nextUrl.isExternal);
        }
    };

    return (
        <>
            {data.heading && (
                <h2 className="font-semibold mb-6 text-skin-dark">
                    {data.heading}
                </h2>
            )}
            <OptionsBox
                data={data.optionsBox}
                onOptionSelected={handleOptionSelected}
            />
        </>
    );
};

export default FormLoanReview;
